module.exports = __webpack_public_path__ + "img/noti-sentfrapproval.fc6f6b3e.svg";